import { useState, useEffect } from "react";
import CookieConsent, { getCookieConsentValue } from "react-cookie-consent";
import ReactGA from "react-ga4";
import Loader from "./app/elements/loader";
import RootLayout from "./layouts/root-layout";
import ScrollToTop from "./app/elements/ScrollToTop";

const GA_MEASUREMENT_ID = "G-XNYDPWTGX1";

const initGA = () => {
  if (!window.gaInitialized) {
    ReactGA.initialize(GA_MEASUREMENT_ID);
    window.gaInitialized = true;
  }
};

export default function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 500);

    // Initialize GA if user already consented
    if (getCookieConsentValue("nivian3pl_consent") === "true") {
      initGA();
    }
  }, []);

  return (
    <>
      {
        isLoading && <Loader />
      }
      <ScrollToTop />
      <RootLayout />
      <CookieConsent
        location="bottom"
        buttonText="Accept"
        declineButtonText="Decline"
        enableDeclineButton
        cookieName="nivian3pl_consent"
        onAccept={initGA}
        style={{
          background: "#1a1a2e",
          padding: "16px 24px",
          alignItems: "center",
        }}
        buttonStyle={{
          background: "#f8b600",
          color: "#1a1a2e",
          fontWeight: "600",
          borderRadius: "4px",
          padding: "10px 24px",
        }}
        declineButtonStyle={{
          background: "transparent",
          border: "1px solid #666",
          color: "#fff",
          borderRadius: "4px",
          padding: "10px 24px",
        }}
        expires={365}
      >
        We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies.{" "}
        <a href="/privacy-policy" style={{ color: "#f8b600" }}>Learn more</a>
      </CookieConsent>
    </>
  );
}
